
document.addEventListener('click', function(e) {
  const button = e.target.closest('.u-collapsible-toggle');
  if (!button) return;
  const item = button.closest('.u-collapsible-item');
  const content = item.querySelector('.u-collapsible-content');
  const isAlreadyActive = item.classList.contains('active');
  const allActiveItems = document.querySelectorAll('.u-collapsible-item.active');
  allActiveItems.forEach(activeItem => {
    activeItem.classList.remove('active');
    const activeContent = activeItem.querySelector('.u-collapsible-content');
    if (activeContent) {
      activeContent.style.maxHeight = null;
    }
  });
  if (!isAlreadyActive) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});


function initupsellslider() {
  var swiper = new Swiper('.u-cart-upsell-swiper', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        loop: false,

        navigation: {
          nextEl: '.u-cart-upsell__next',
          prevEl: '.u-cart-upsell__prev',
        },
      });
}  

document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-upsell-atc]');
  if (!btn) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('btn--loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
    .then(response => response.json())
    .then(item => {
      btn.classList.remove('btn--loading');

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: item,
          addToCartBtn: btn
        }
      }));

      setTimeout(function() {
        initupsellslider();
      }, 2000);
    })
    .catch(err => {
      btn.classList.remove('btn--loading');
      console.error('Upsell add to cart failed:', err);
    });
});

document.addEventListener('click', function (e) {
  const link = e.target.closest('.js-cart-remove');
  if (!link) return;
  e.preventDefault();
  const key = link.dataset.key;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
    .then((res) => res.json())
    .then((cart) => {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    })
    .catch((err) => console.error('Cart remove error:', err));
});